import React from 'react';
import { BrowserRouter } from 'react-router-dom';

const ReactRouter = ({ children, ...props }) => (
  <BrowserRouter {...props}>{children}</BrowserRouter>
);
export default ReactRouter;
